<template>
<div class="table">
  <div class="bold table__title" v-if="title">
    {{ title }}
  </div>
  <div class="table__content">
    <div v-if="isEmpty" class="table__item table__item__empty">
      {{ emptyText }}
    </div>
    <div
      v-else
      class="table__item"
      v-for="(item, index) in items" :key="item + index">
       {{ item }}
       <font-awesome-icon class="table__item__circle"
                          v-if="displayCheck"
                          :icon="['fal', 'check-circle']" />
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'NextTable',
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: '',
    },
    displayCheck: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters['dimensionStore/isMobile'];
    },
  },
};
</script>

<style scoped lang="scss">
  .table{

    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 4px;

    &__title{
      color: $--color-secondary;
      border-radius: 4px 4px 0 0;
      font-size: 17px;
      min-height: 32px;
      padding: 10px;
      display: flex;
      align-items: center;
      background-color: $--color-background-sub-menu;
    }

    &__content {
      display: grid;
      grid-template-columns: 1fr;
      grid-auto-rows: min-content;
    }

    &__item{
      display: flex;
      font-size: 15px;
      justify-content: space-between;
      padding: 10px;
      align-items: center;

      &__empty {
        justify-content: center;
      }

      &__circle{
        margin-left: 5px;
        color: $--color-primary;
      }

      &:nth-child(odd){
        background-color: $--color-background-sub-menu-light;
      }
    }
  }
</style>
